import React from "react";

export default function MovieContainer({ children }) {
  return (
    <div
      className="grid grid-cols-2 row-gap-5 col-gap-4 sm:grid-cols-3 xl:grid-cols-5"
      style={{ gridAutoRows: "minmax(420px, 1fr)" }}
    >
      {children}
    </div>
  );
}
